module.exports = __webpack_public_path__ + "img/red.c971616e.png";